import { GsFormField } from 'libs/shared/src/components';

export const ZOOM_SCHEMA_FIELDS: GsFormField<never>[] = [
  {
    formControlName: 'zoomable',
    label: 'schema.zoom.enable',
    description: 'schema.zoom.enableDescription',
    type: 'checkbox',
    default: false,
    groupingName: 'schema.zoom.group'
  },
  {
    formControlName: 'zoomFactor',
    label: 'schema.zoom.factor',
    type: 'number',
    default: 0.5,
    groupingName: 'schema.zoom.group',
    min: 0.5,
    max: 5,
    step: 0.1,
    if: {
      args: [
        {
          formControlName: 'zoomable',
          value: true
        }
      ]
    }
  }
];
